// "use client";

// export default function Field({ label, children, hint }) {
//   return (
//     <label className="block">
//       <span className="text-[13px] font-semibold text-slate-900">{label}</span>
//       <div className="mt-1">{children}</div>
//       {hint ? (
//         <p className="mt-1 text-xs text-gray-500 select-none">{hint}</p>
//       ) : null}
//     </label>
//   );
// }


// app/components/ui/Field.jsx
"use client";

import React, { useId } from "react";

/**
 * Props
 * - label: string | ReactNode
 * - hint?: string | ReactNode
 * - htmlFor?: string  // if you pass the input's id, we'll link the label
 * - required?: boolean
 * - actions?: ReactNode // right-aligned slot next to the label (e.g., buttons)
 * - className?, labelClassName?, hintClassName?
 */
export default function Field({
  label,
  children,
  hint,
  htmlFor,
  required = false,
  actions = null,
  className = "",
  labelClassName = "",
  hintClassName = "",
}) {
  const uid = useId();
  const hintId = hint ? `${uid}-hint` : undefined;

  return (
    <div className={["block", className].filter(Boolean).join(" ")}>
      {(label || actions) && (
        <div className="flex items-center justify-between gap-2">
          {label ? (
            htmlFor ? (
              <label
                htmlFor={htmlFor}
                className={["text-[13px] font-semibold text-slate-900", labelClassName]
                  .filter(Boolean)
                  .join(" ")}
              >
                {label}
                {required && <span className="ml-1 text-orange-600">*</span>}
              </label>
            ) : (
              <span
                className={["text-[13px] font-semibold text-slate-900", labelClassName]
                  .filter(Boolean)
                  .join(" ")}
              >
                {label}
                {required && <span className="ml-1 text-orange-600">*</span>}
              </span>
            )
          ) : (
            <span />
          )}
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      )}

      <div className="mt-1" {...(hintId ? { "aria-describedby": hintId } : {})}>
        {children}
      </div>

      {hint ? (
        <p id={hintId} className={["mt-1 text-xs text-gray-500 select-none", hintClassName].filter(Boolean).join(" ")}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
